// material-ui
import { Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

//Component declaration for `AuthFooter`
const AuthFooter = () => (
    <Stack direction="row" justifyContent="center">
        <Typography sx={{ fontSize: '14px', marginTop: '30px', marginBottom: '30px' }}>
            &copy; Copyright All Rights Reserved{' '}
            <a
                href="https://anpr.in/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#03045E', fontSize: 'bold', textDecoration: 'none', marginRight: '4px' }}
            >
                ANPR
            </a>
            -
            <a
                href="https://www.surajinformatics.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#03045E', fontSize: 'bold', textDecoration: 'none', marginLeft: '4px' }}
            >
                SIPL
            </a>
        </Typography>
    </Stack>
);

export default AuthFooter;
